var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatterns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 4155,
    viewBox: "0 0 1920 4155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-FUNDO"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 4155
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FUNDO",
    clipPath: "url(#clip-FUNDO)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_183",
    "data-name": "Grupo 183",
    transform: "translate(0 10)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "pattern2",
    transform: "translate(12.336 1862.022)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_9487",
    "data-name": "Frame 9487",
    transform: "translate(0 0)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6970",
    "data-name": "Group 6970",
    transform: "translate(1149.033 399.797)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane",
    transform: "translate(219.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon",
    transform: "translate(176.412 102.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular",
    transform: "translate(294.035 102.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van",
    transform: "translate(93.892 21.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag",
    transform: "translate(0 213.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.095)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-12",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip",
    transform: "translate(262.91 206.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-13",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-14",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.433)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register",
    transform: "translate(141.989 259.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-15",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6979",
    "data-name": "Group 6979",
    transform: "translate(987.342)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-2",
    "data-name": "majesticons:airplane",
    transform: "translate(-465.994 -197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-16",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-2",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.519 102.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-17",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-18",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-19",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-20",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-21",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-22",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-23",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-2",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.77 84.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-24",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-2",
    "data-name": "la:shuttle-van",
    transform: "translate(0 21.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-25",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-2",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(14.191 185.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-26",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.095)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-27",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-2",
    "data-name": "bx:bx-trip",
    transform: "translate(169.018 206.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-28",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-29",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.432)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-2",
    "data-name": "la:cash-register",
    transform: "translate(45.746 275.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-30",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6983",
    "data-name": "Group 6983",
    transform: "translate(35.027 176.404)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-3",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(253.271 43.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-31",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-32",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-33",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-34",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.524 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-35",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-36",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-37",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-3",
    "data-name": "fluent:building-24-regular",
    transform: "translate(340.493 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-38",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-3",
    "data-name": "bx:bx-trip",
    transform: "translate(0 158.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-39",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-40",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.432)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-3",
    "data-name": "la:cash-register",
    transform: "translate(255.767 165.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-41",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line",
    transform: "translate(159.293 194.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-42",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-43",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.067 37.158)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-44",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-45",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.779)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6972",
    "data-name": "Group 6972",
    transform: "translate(1613.656 447.334)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-3",
    "data-name": "majesticons:airplane",
    transform: "translate(163.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-46",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-4",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(120.289 102.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-47",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-48",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.955 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-49",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-50",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-51",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-52",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-53",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-4",
    "data-name": "fluent:building-24-regular",
    transform: "translate(220.541 84.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-54",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-3",
    "data-name": "la:shuttle-van",
    transform: "translate(37.77 21.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-55",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-3",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0 122.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-56",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.095)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-57",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-4",
    "data-name": "bx:bx-trip",
    transform: "translate(206.788 206.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-58",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-59",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-4",
    "data-name": "la:cash-register",
    transform: "translate(109.755 233.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-60",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6985",
    "data-name": "Group 6985",
    transform: "translate(1478.987 84.508)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-5",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(374.389 80.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-61",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-62",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.955 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-63",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.668 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-64",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-65",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-66",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-67",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-4",
    "data-name": "la:shuttle-van",
    transform: "translate(291.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-68",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-5",
    "data-name": "la:cash-register",
    transform: "translate(324.426 244.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-69",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-2",
    "data-name": "clarity:boat-line",
    transform: "translate(265.21 90.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-70",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-71",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-72",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-73",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-3",
    "data-name": "clarity:boat-line",
    transform: "translate(0 278.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-74",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-75",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.067 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-76",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.03 11.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-77",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.779)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6982",
    "data-name": "Group 6982",
    transform: "translate(254.483 477.973)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-5",
    "data-name": "majesticons:airplane",
    transform: "translate(141.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-78",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-6",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.518 119.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-79",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-80",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-81",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-82",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.524 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-83",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-84",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-85",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-5",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.771 102.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-86",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-5",
    "data-name": "la:shuttle-van",
    transform: "translate(0 38.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-87",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-4",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.108 183.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-88",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.096)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-89",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6981",
    "data-name": "Group 6981",
    transform: "translate(1409.756 20.99)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-6",
    "data-name": "majesticons:airplane",
    transform: "translate(78.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-90",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.418.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-7",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.147 62.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-91",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-92",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.371)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-93",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-94",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-95",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-96",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-97",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-6",
    "data-name": "fluent:building-24-regular",
    transform: "translate(148.752 45.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-98",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257Zm20.63,29.858v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-6",
    "data-name": "la:shuttle-van",
    transform: "translate(0 5.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-99",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-5",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.49 99.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-100",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-101",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,0,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-5",
    "data-name": "bx:bx-trip",
    transform: "translate(118.35 115.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-102",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,1,1,0-10.858h15.2a7.6,7.6,0,1,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,1,0,0,19.544H30.6a22.616,22.616,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-103",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.057)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-6",
    "data-name": "la:cash-register",
    transform: "translate(67.946 165.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-104",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.761,22.761,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6973",
    "data-name": "Group 6973",
    transform: "translate(1577.592 238.143)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-7",
    "data-name": "majesticons:airplane",
    transform: "translate(86.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-105",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.418.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-7",
    "data-name": "la:shuttle-van",
    transform: "translate(0 5.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-106",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-6",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.491 99.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-107",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-108",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,0,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-6",
    "data-name": "bx:bx-trip",
    transform: "translate(118.35 115.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-109",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,1,1,0-10.858h15.2a7.6,7.6,0,1,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,1,0,0,19.544H30.6a22.616,22.616,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-110",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.058)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-7",
    "data-name": "la:cash-register",
    transform: "translate(63.603 165.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-111",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.761,22.761,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6978",
    "data-name": "Group 6978",
    transform: "translate(622.813 485.513)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-8",
    "data-name": "majesticons:airplane",
    transform: "translate(93.177 190.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-112",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.418.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-8",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(76.891 112.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-113",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-114",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.372 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-115",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-116",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-117",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-118",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.772 33.659)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-119",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.772 33.659)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-7",
    "data-name": "fluent:building-24-regular",
    transform: "translate(149.234 97.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-120",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257Zm20.63,29.858v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-8",
    "data-name": "la:shuttle-van",
    transform: "translate(33.511 16.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-121",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-7",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0 143.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-122",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-123",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,0,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-7",
    "data-name": "bx:bx-trip",
    transform: "translate(178.919 151.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-124",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,1,1,0-10.858h15.2a7.6,7.6,0,1,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,1,0,0,19.544H30.6a22.616,22.616,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-125",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.058)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-8",
    "data-name": "la:cash-register",
    transform: "translate(153.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-126",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.761,22.761,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6980",
    "data-name": "Group 6980",
    transform: "translate(635.818 99.67)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-9",
    "data-name": "majesticons:airplane",
    transform: "translate(58.666 177.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-127",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.418.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-9",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.146 68.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-128",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-129",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.371)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-130",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-131",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-132",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-133",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-134",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-8",
    "data-name": "fluent:building-24-regular",
    transform: "translate(148.751 51.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-135",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257Zm20.63,29.858v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-9",
    "data-name": "la:shuttle-van",
    transform: "translate(0 11.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-136",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-8",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.49 105.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-137",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-138",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,0,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-8",
    "data-name": "bx:bx-trip",
    transform: "translate(118.349 121.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-139",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,1,1,0-10.858h15.2a7.6,7.6,0,1,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,1,0,0,19.544H30.6a22.616,22.616,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-140",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.057)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-9",
    "data-name": "la:cash-register",
    transform: "translate(87.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-141",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.761,22.761,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-4",
    "data-name": "clarity:boat-line",
    transform: "translate(783.863 317.532)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-142",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.046)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-143",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-144",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-145",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6982-2",
    "data-name": "Group 6982",
    transform: "translate(0 457.433)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-10",
    "data-name": "majesticons:airplane",
    transform: "translate(58.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-146",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-10",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(0 119.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-147",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-148",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-149",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-150",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.524 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-151",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-152",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-153",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-9",
    "data-name": "fluent:building-24-regular",
    transform: "translate(100.253 102.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-154",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-9",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(82.59 281.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-155",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.096)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-156",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_9486",
    "data-name": "Frame 9486",
    transform: "translate(5.795 598.042)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6970-2",
    "data-name": "Group 6970",
    transform: "translate(887.991 623.958)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-11",
    "data-name": "majesticons:airplane",
    transform: "translate(126.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-157",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-11",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.52 102.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-158",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-159",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-160",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-161",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-162",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-163",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-164",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-10",
    "data-name": "fluent:building-24-regular",
    transform: "translate(200.143 102.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-165",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-10",
    "data-name": "la:shuttle-van",
    transform: "translate(0 21.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-166",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-9",
    "data-name": "bx:bx-trip",
    transform: "translate(169.018 206.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-167",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-168",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-10",
    "data-name": "la:cash-register",
    transform: "translate(48.097 259.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-169",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6979-2",
    "data-name": "Group 6979",
    transform: "translate(781.505 30.89)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-12",
    "data-name": "majesticons:airplane",
    transform: "translate(126.006 236.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-170",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-12",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(230.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-171",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-172",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-173",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-174",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.287)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-175",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-176",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-177",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-11",
    "data-name": "fluent:building-24-regular",
    transform: "translate(262.77 267.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-178",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-11",
    "data-name": "la:shuttle-van",
    transform: "translate(0 258.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-179",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-10",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.108 403.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-180",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.096)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-181",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-10",
    "data-name": "bx:bx-trip",
    transform: "translate(169.018 443.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-182",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-183",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-11",
    "data-name": "la:cash-register",
    transform: "translate(76.327 496.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-184",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6983-2",
    "data-name": "Group 6983",
    transform: "translate(0 291.716)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-13",
    "data-name": "majesticons:airplane",
    transform: "translate(126.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-185",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-13",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(95.547 128.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-186",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-187",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-188",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-189",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.526 16.287)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-190",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-191",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-192",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-12",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.769 84.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-193",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-12",
    "data-name": "la:shuttle-van",
    transform: "translate(0 21.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-194",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-11",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.107 166.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-195",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.096)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-196",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-11",
    "data-name": "bx:bx-trip",
    transform: "translate(210.276 225.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-197",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-198",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-12",
    "data-name": "la:cash-register",
    transform: "translate(98.042 250.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-199",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-5",
    "data-name": "clarity:boat-line",
    transform: "translate(1.568 279.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-200",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.046)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-201",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.067 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-202",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.049)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-203",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.778)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6972-2",
    "data-name": "Group 6972",
    transform: "translate(1428.789 715.165)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-14",
    "data-name": "majesticons:airplane",
    transform: "translate(154.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-204",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-13",
    "data-name": "la:shuttle-van",
    transform: "translate(28.121 21.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-205",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-12",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0 118.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-206",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-207",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-12",
    "data-name": "bx:bx-trip",
    transform: "translate(197.139 206.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-208",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-209",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-13",
    "data-name": "la:cash-register",
    transform: "translate(100.106 233.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-210",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6985-2",
    "data-name": "Group 6985",
    transform: "translate(1306.471 231.42)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-14",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(352.391 201.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-211",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-212",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.955 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-213",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.668 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-214",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.287)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-215",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-216",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-217",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-14",
    "data-name": "la:shuttle-van",
    transform: "translate(468.872 51.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-218",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-14",
    "data-name": "la:cash-register",
    transform: "translate(298.427 332.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-219",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-15",
    "data-name": "la:cash-register",
    transform: "translate(324.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-220",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-6",
    "data-name": "clarity:boat-line",
    transform: "translate(243.21 211.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-221",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-222",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-223",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.049)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-224",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-7",
    "data-name": "clarity:boat-line",
    transform: "translate(0 322.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-225",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-226",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.067 37.158)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-227",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.03 11.05)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-228",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.779)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6977",
    "data-name": "Group 6977",
    transform: "translate(1500.34 1066.95)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-16",
    "data-name": "majesticons:airplane",
    transform: "translate(126.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-229",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-15",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.519 102.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-230",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-231",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-232",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-233",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-234",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-235",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-236",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-13",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.771 84.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-237",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-15",
    "data-name": "la:shuttle-van",
    transform: "translate(0 21.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-238",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-13",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(17.48 183.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-239",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-240",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-13",
    "data-name": "bx:bx-trip",
    transform: "translate(169.018 206.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-241",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-242",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-16",
    "data-name": "la:cash-register",
    transform: "translate(76.328 259.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-243",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6974",
    "data-name": "Group 6974",
    transform: "translate(1050.834 286.792)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-17",
    "data-name": "majesticons:airplane",
    transform: "translate(141.207 701.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-56",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-244",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-16",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.519 821.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-57",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-245",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-246",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.954 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-247",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.666 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-248",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-249",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-250",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-251",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-14",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.77 804.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-58",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-252",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-16",
    "data-name": "la:shuttle-van",
    transform: "translate(0 740.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-253",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-14",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.108 885.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-254",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-255",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-14",
    "data-name": "bx:bx-trip",
    transform: "translate(169.018 925.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-256",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-257",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.431)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-17",
    "data-name": "la:cash-register",
    transform: "translate(76.328 978.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-258",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-8",
    "data-name": "clarity:boat-line",
    transform: "translate(106.043 918.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-259",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-260",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.04 22.294)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-261",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.219 6.628)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-262",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.267)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-9",
    "data-name": "clarity:boat-line",
    transform: "translate(205.933 1035.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-263",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-264",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.041 22.294)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-265",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.219 6.628)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-266",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.268)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-10",
    "data-name": "clarity:boat-line",
    transform: "translate(505.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-267",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-268",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.041 22.295)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-269",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.219 6.63)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-270",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.269)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6982-3",
    "data-name": "Group 6982",
    transform: "translate(23.282 643.502)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-18",
    "data-name": "majesticons:airplane",
    transform: "translate(167.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-271",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-17",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(109.181 119.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-272",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-273",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-274",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-275",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.524 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-276",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-277",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-278",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-15",
    "data-name": "fluent:building-24-regular",
    transform: "translate(209.433 102.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-62",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-279",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-17",
    "data-name": "la:shuttle-van",
    transform: "translate(26.664 38.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-280",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-15",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(26.769 183.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-63",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-281",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-282",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-15",
    "data-name": "bx:bx-trip",
    transform: "translate(195.68 223.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-283",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-284",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.67 43.431)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-18",
    "data-name": "la:cash-register",
    transform: "translate(102.99 276.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-285",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-11",
    "data-name": "clarity:boat-line",
    transform: "translate(0 301.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-286",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-287",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-288",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.031 11.049)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-289",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6984",
    "data-name": "Group 6984",
    transform: "translate(128.12 1003.977)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-19",
    "data-name": "majesticons:airplane",
    transform: "translate(182.467 228.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-64",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-290",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,1,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-18",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.52 130.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-65",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-291",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-292",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-293",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-294",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.524 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-295",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-296",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-297",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-16",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.769 112.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-298",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-18",
    "data-name": "la:shuttle-van",
    transform: "translate(0 49.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-299",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-16",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.108 194.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-67",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-300",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-301",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,0,0,0,7.238",
    transform: "translate(24.141 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-16",
    "data-name": "bx:bx-trip",
    transform: "translate(123.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-302",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,1,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,1,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-303",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.431)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-19",
    "data-name": "la:cash-register",
    transform: "translate(76.329 287.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-304",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6981-2",
    "data-name": "Group 6981",
    transform: "translate(890.617)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-20",
    "data-name": "majesticons:airplane",
    transform: "translate(385.722 257.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-68",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-305",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.418.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-19",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(372.657 320.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-306",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-307",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.371)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-308",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-309",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-310",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-311",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.771 33.658)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-312",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.771 33.658)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-17",
    "data-name": "fluent:building-24-regular",
    transform: "translate(456.262 302.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-313",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257Zm20.63,29.858v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-19",
    "data-name": "la:shuttle-van",
    transform: "translate(307.511 263.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-314",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-17",
    "data-name": "iconoir:shopping-bag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-71",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-315",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-316",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,0,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-17",
    "data-name": "bx:bx-trip",
    transform: "translate(425.861 372.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-317",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,1,1,0-10.858h15.2a7.6,7.6,0,1,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,1,0,0,19.544H30.6a22.616,22.616,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-318",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.058)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-20",
    "data-name": "la:cash-register",
    transform: "translate(375.457 422.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-319",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.761,22.761,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6975",
    "data-name": "Group 6975",
    transform: "translate(513.545 834.417)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-21",
    "data-name": "majesticons:airplane",
    transform: "translate(58.666 177.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-72",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-320",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.418.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-20",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.145 68.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-321",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-322",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-323",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-324",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-325",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.372)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-326",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-327",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-18",
    "data-name": "fluent:building-24-regular",
    transform: "translate(163.951 58.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-74",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-328",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257Zm20.63,29.858v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-20",
    "data-name": "la:shuttle-van",
    transform: "translate(0 11.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-329",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-18",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.489 105.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-75",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-330",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-331",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,0,0,0,4.343",
    transform: "translate(14.484)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-18",
    "data-name": "bx:bx-trip",
    transform: "translate(118.349 121.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-332",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,1,1,0-10.858h15.2a7.6,7.6,0,1,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,1,0,0,19.544H30.6a22.616,22.616,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-333",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.059)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-21",
    "data-name": "la:cash-register",
    transform: "translate(87.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-334",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.761,22.761,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6978-2",
    "data-name": "Group 6978",
    transform: "translate(525.568 593.377)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-22",
    "data-name": "majesticons:airplane",
    transform: "translate(58.665 177.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-76",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-335",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.418.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-21",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.144 68.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-77",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-336",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-337",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.372)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-338",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-339",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-340",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.372)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-341",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-342",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-19",
    "data-name": "fluent:building-24-regular",
    transform: "translate(148.751 51.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-343",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257Zm20.63,29.858v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-21",
    "data-name": "la:shuttle-van",
    transform: "translate(0 11.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-344",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-19",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.489 105.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-345",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-346",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,0,0,0,4.343",
    transform: "translate(14.484)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-19",
    "data-name": "bx:bx-trip",
    transform: "translate(144.407 138.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-347",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,1,1,0-10.858h15.2a7.6,7.6,0,1,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,1,0,0,19.544H30.6a22.616,22.616,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-348",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.059)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-22",
    "data-name": "la:cash-register",
    transform: "translate(87.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-349",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.761,22.761,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6980-2",
    "data-name": "Group 6980",
    transform: "translate(330.705 255.48)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-23",
    "data-name": "majesticons:airplane",
    transform: "translate(141.176 177.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-80",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-350",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.418.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-22",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(147.656 68.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-81",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-351",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-352",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.371 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-353",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-354",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-355",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-356",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-357",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-20",
    "data-name": "fluent:building-24-regular",
    transform: "translate(231.261 51.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-82",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-358",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.536.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257Zm20.63,29.858v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-22",
    "data-name": "la:shuttle-van",
    transform: "translate(82.51 11.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-359",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-20",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0 49.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-83",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-360",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.857)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-361",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,0,0,0,4.343",
    transform: "translate(14.484)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-20",
    "data-name": "bx:bx-trip",
    transform: "translate(200.859 121.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-362",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,1,1,0-10.858h15.2a7.6,7.6,0,1,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,1,0,0,19.544H30.6a22.616,22.616,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-363",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.058)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-23",
    "data-name": "la:cash-register",
    transform: "translate(169.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-364",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.761,22.761,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-12",
    "data-name": "clarity:boat-line",
    transform: "translate(602.653 514.9)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-365",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-366",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-367",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.049)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-368",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-13",
    "data-name": "clarity:boat-line",
    transform: "translate(808.207 977.339)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-369",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-370",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.041 22.294)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-371",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.218 6.628)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-372",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.268)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-14",
    "data-name": "clarity:boat-line",
    transform: "translate(66.955 1140.203)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-373",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-374",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.041 22.294)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-375",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.22 6.629)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-376",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.268)",
    fill: "#1e3460"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "pattern2-2",
    "data-name": "pattern2",
    transform: "translate(0 0)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_9487-2",
    "data-name": "Frame 9487",
    transform: "translate(186.957)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6970-3",
    "data-name": "Group 6970",
    transform: "translate(902.831 356.127)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-24",
    "data-name": "majesticons:airplane",
    transform: "translate(126.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-84",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-377",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-23",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.519 102.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-378",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-379",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-380",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-381",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-382",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-383",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-384",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-21",
    "data-name": "fluent:building-24-regular",
    transform: "translate(200.143 102.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-86",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-385",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-23",
    "data-name": "la:shuttle-van",
    transform: "translate(0 21.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-386",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-21",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.108 166.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-87",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-387",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.095)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-388",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-21",
    "data-name": "bx:bx-trip",
    transform: "translate(169.018 206.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-389",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-390",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.433)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-24",
    "data-name": "la:cash-register",
    transform: "translate(48.097 259.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-391",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6979-3",
    "data-name": "Group 6979",
    transform: "translate(794.591)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-25",
    "data-name": "majesticons:airplane",
    transform: "translate(126.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-88",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-392",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-24",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.519 102.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-89",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-393",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-394",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-395",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-396",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-397",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-398",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-399",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-22",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.77 84.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-90",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-400",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-24",
    "data-name": "la:shuttle-van",
    transform: "translate(0 21.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-401",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-22",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(14.191 185.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-91",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-402",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.095)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-403",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-22",
    "data-name": "bx:bx-trip",
    transform: "translate(169.018 206.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-404",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-405",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.432)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-25",
    "data-name": "la:cash-register",
    transform: "translate(45.746 275.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-406",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6983-3",
    "data-name": "Group 6983",
    transform: "translate(0 91.712)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-26",
    "data-name": "majesticons:airplane",
    transform: "translate(126.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-92",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-407",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-25",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(95.546 128.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-93",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-408",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-409",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-410",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-411",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.524 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-412",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-413",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-414",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-23",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.768 84.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-94",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-415",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-25",
    "data-name": "la:shuttle-van",
    transform: "translate(0 21.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-416",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-23",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.107 166.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-95",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-417",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.095)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-418",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-23",
    "data-name": "bx:bx-trip",
    transform: "translate(210.275 225.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-419",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-420",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.432)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-26",
    "data-name": "la:cash-register",
    transform: "translate(98.041 250.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-421",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-15",
    "data-name": "clarity:boat-line",
    transform: "translate(1.568 279.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-422",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-423",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.067 37.158)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-424",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-425",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.779)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6972-3",
    "data-name": "Group 6972",
    transform: "translate(1420.906 447.334)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-27",
    "data-name": "majesticons:airplane",
    transform: "translate(163.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-96",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-426",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-26",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(120.289 102.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-97",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-427",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-428",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.955 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-429",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-430",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-431",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-432",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-433",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-24",
    "data-name": "fluent:building-24-regular",
    transform: "translate(220.54 84.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-98",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-434",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-26",
    "data-name": "la:shuttle-van",
    transform: "translate(37.77 21.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-435",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-24",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0 122.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-99",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-436",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.095)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-437",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-24",
    "data-name": "bx:bx-trip",
    transform: "translate(206.788 206.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-438",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-439",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6985-3",
    "data-name": "Group 6985",
    transform: "translate(1308.237 84.508)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-27",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(352.389 80.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-100",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-440",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-441",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.955 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-442",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.668 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-443",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-444",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-445",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-446",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-27",
    "data-name": "la:shuttle-van",
    transform: "translate(269.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-447",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-27",
    "data-name": "la:cash-register",
    transform: "translate(298.426 211.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-448",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-16",
    "data-name": "clarity:boat-line",
    transform: "translate(243.21 90.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-449",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-450",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-451",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-452",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-17",
    "data-name": "clarity:boat-line",
    transform: "translate(0 201.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-453",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-454",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.067 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-455",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.03 11.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-456",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.779)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6982-4",
    "data-name": "Group 6982",
    transform: "translate(61.731 477.973)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-29",
    "data-name": "majesticons:airplane",
    transform: "translate(141.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-101",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-457",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-28",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.518 119.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-102",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-458",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-459",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-460",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-461",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.524 16.288)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-462",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-463",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-464",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-25",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.771 102.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-103",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-465",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-28",
    "data-name": "la:shuttle-van",
    transform: "translate(0 38.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-466",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-25",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.108 183.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-104",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-467",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.096)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-468",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6981-3",
    "data-name": "Group 6981",
    transform: "translate(1217.006 20.99)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-30",
    "data-name": "majesticons:airplane",
    transform: "translate(78.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-105",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-469",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.417.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-29",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.147 62.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-106",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-470",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-471",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.371)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-472",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-473",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-474",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-475",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-476",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-26",
    "data-name": "fluent:building-24-regular",
    transform: "translate(148.751 45.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-107",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-477",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257ZM23.887,34.744v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-29",
    "data-name": "la:shuttle-van",
    transform: "translate(0 5.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-478",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-26",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.49 99.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-108",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-479",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-480",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,1,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-25",
    "data-name": "bx:bx-trip",
    transform: "translate(118.35 115.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-481",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,0,1,0-10.858h15.2a7.6,7.6,0,0,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,0,0,0,19.544H30.6a22.617,22.617,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-482",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.057)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-28",
    "data-name": "la:cash-register",
    transform: "translate(67.946 165.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-483",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.76,22.76,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6973-2",
    "data-name": "Group 6973",
    transform: "translate(1384.843 238.143)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-31",
    "data-name": "majesticons:airplane",
    transform: "translate(86.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-109",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-484",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.417.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-30",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.147 62.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-110",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-485",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-486",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.371 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-487",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-488",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-489",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-490",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-491",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-27",
    "data-name": "fluent:building-24-regular",
    transform: "translate(148.751 45.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-111",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-492",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257ZM23.887,34.744v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-30",
    "data-name": "la:shuttle-van",
    transform: "translate(0 5.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-493",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-27",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.491 99.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-112",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-494",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-495",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,1,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-26",
    "data-name": "bx:bx-trip",
    transform: "translate(118.35 115.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-496",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,0,1,0-10.858h15.2a7.6,7.6,0,0,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,0,0,0,19.544H30.6a22.617,22.617,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-497",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.058)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-29",
    "data-name": "la:cash-register",
    transform: "translate(63.603 165.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-498",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.76,22.76,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6978-3",
    "data-name": "Group 6978",
    transform: "translate(538.573 440.071)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-32",
    "data-name": "majesticons:airplane",
    transform: "translate(58.666 177.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-113",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-499",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.417.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-31",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.145 68.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-114",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-500",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-501",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.372 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-502",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-503",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-504",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-505",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.772 33.659)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-506",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.772 33.659)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-28",
    "data-name": "fluent:building-24-regular",
    transform: "translate(148.75 51.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-115",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-507",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257ZM23.887,34.744v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-31",
    "data-name": "la:shuttle-van",
    transform: "translate(0 11.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-508",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-28",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.489 105.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-116",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-509",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-510",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,1,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-27",
    "data-name": "bx:bx-trip",
    transform: "translate(144.407 138.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-511",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,0,1,0-10.858h15.2a7.6,7.6,0,0,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,0,0,0,19.544H30.6a22.617,22.617,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-512",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.058)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-30",
    "data-name": "la:cash-register",
    transform: "translate(87.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-513",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.76,22.76,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6980-3",
    "data-name": "Group 6980",
    transform: "translate(443.067 99.67)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-33",
    "data-name": "majesticons:airplane",
    transform: "translate(58.666 177.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-117",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-514",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.417.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-32",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.146 68.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-118",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-515",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-516",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.371)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-517",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-518",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-519",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-520",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-521",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.771 33.659)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-29",
    "data-name": "fluent:building-24-regular",
    transform: "translate(148.751 51.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-119",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-522",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257ZM23.887,34.744v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-32",
    "data-name": "la:shuttle-van",
    transform: "translate(0 11.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-523",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-29",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.49 105.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-120",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-524",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-525",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,1,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-28",
    "data-name": "bx:bx-trip",
    transform: "translate(118.349 121.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-526",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,0,1,0-10.858h15.2a7.6,7.6,0,0,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,0,0,0,19.544H30.6a22.617,22.617,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-527",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.057)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-31",
    "data-name": "la:cash-register",
    transform: "translate(87.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-528",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.76,22.76,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-18",
    "data-name": "clarity:boat-line",
    transform: "translate(591.112 317.532)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-529",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.046)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-530",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-531",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-532",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame_9486-2",
    "data-name": "Frame 9486",
    transform: "translate(0 647.58)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6970-4",
    "data-name": "Group 6970",
    transform: "translate(936.09 361.323)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-34",
    "data-name": "majesticons:airplane",
    transform: "translate(77.909 31.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-121",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-533",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-33",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(34.422 133.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-122",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-534",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-535",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-536",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-537",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-538",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-539",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-540",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-30",
    "data-name": "fluent:building-24-regular",
    transform: "translate(152.046 133.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-123",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-541",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-33",
    "data-name": "la:shuttle-van",
    transform: "translate(846.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-542",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-29",
    "data-name": "bx:bx-trip",
    transform: "translate(120.921 237.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-543",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-544",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-32",
    "data-name": "la:cash-register",
    transform: "translate(0 290.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-545",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6979-4",
    "data-name": "Group 6979",
    transform: "translate(781.506 57.941)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-35",
    "data-name": "majesticons:airplane",
    transform: "translate(145.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-124",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-546",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-31",
    "data-name": "fluent:building-24-regular",
    transform: "translate(268.77 15.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-125",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-547",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-34",
    "data-name": "la:shuttle-van",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-548",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-33",
    "data-name": "la:cash-register",
    transform: "translate(145.327 252.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-549",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6983-4",
    "data-name": "Group 6983",
    transform: "translate(0 60.296)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-36",
    "data-name": "majesticons:airplane",
    transform: "translate(126.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-126",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-550",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-34",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(95.547 128.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-127",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-551",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-552",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-553",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-554",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.526 16.287)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-555",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-556",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-557",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-32",
    "data-name": "fluent:building-24-regular",
    transform: "translate(246.467 83.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-128",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-558",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-35",
    "data-name": "la:shuttle-van",
    transform: "translate(0 21.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-559",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-30",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(1796.107 99.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-129",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-560",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.096)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-561",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-30",
    "data-name": "bx:bx-trip",
    transform: "translate(232 262.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-562",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-563",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-34",
    "data-name": "la:cash-register",
    transform: "translate(98.042 250.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-564",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-19",
    "data-name": "clarity:boat-line",
    transform: "translate(0 298.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-565",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.046)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-566",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.067 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-567",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.049)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-568",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.778)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6972-4",
    "data-name": "Group 6972",
    transform: "translate(1428.791 483.745)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-37",
    "data-name": "majesticons:airplane",
    transform: "translate(154.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-130",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-569",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-36",
    "data-name": "la:shuttle-van",
    transform: "translate(28.121 21.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-570",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-31",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0 118.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-131",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-571",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-572",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-31",
    "data-name": "bx:bx-trip",
    transform: "translate(197.138 206.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-573",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-574",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-35",
    "data-name": "la:cash-register",
    transform: "translate(100.106 233.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-575",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6985-4",
    "data-name": "Group 6985",
    transform: "translate(1306.473)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-35",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(390.035 239.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-132",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-576",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-577",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.955 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-578",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.668 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-579",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.287)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-580",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-581",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-582",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.099)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-37",
    "data-name": "la:shuttle-van",
    transform: "translate(324.974 118.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-583",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-36",
    "data-name": "la:cash-register",
    transform: "translate(298.426 332.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-584",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-37",
    "data-name": "la:cash-register",
    transform: "translate(324.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-585",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-20",
    "data-name": "clarity:boat-line",
    transform: "translate(243.21 211.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-586",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-587",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-588",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.049)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-589",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-21",
    "data-name": "clarity:boat-line",
    transform: "translate(0 322.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-590",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.048)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-591",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.067 37.158)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-592",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.03 11.05)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-593",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.779)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6977-2",
    "data-name": "Group 6977",
    transform: "translate(1563.552 985.005)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-36",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.039 17.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-133",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-594",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-595",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-596",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-597",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-598",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-599",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-600",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-33",
    "data-name": "fluent:building-24-regular",
    transform: "translate(165.291 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-134",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-601",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-32",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0 99.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-135",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-602",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-603",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-32",
    "data-name": "bx:bx-trip",
    transform: "translate(151.538 121.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-604",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-605",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.43)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-38",
    "data-name": "la:cash-register",
    transform: "translate(58.847 174.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-606",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6974-2",
    "data-name": "Group 6974",
    transform: "translate(1050.837 55.372)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-39",
    "data-name": "majesticons:airplane",
    transform: "translate(141.207 701.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-136",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-607",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-37",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.519 821.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-137",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-608",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-609",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.954 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-610",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.666 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-611",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.525 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-612",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-613",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-614",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-34",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.77 804.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-138",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-615",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-38",
    "data-name": "la:shuttle-van",
    transform: "translate(0 740.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-616",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-33",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.108 931.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-139",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-617",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-618",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-33",
    "data-name": "bx:bx-trip",
    transform: "translate(195.647 931.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-619",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-620",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.431)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-39",
    "data-name": "la:cash-register",
    transform: "translate(-621.672 1057.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-621",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-22",
    "data-name": "clarity:boat-line",
    transform: "translate(106.043 964.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-622",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-623",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.04 22.294)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-624",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.219 6.628)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-625",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.267)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-23",
    "data-name": "clarity:boat-line",
    transform: "translate(221.607 1083.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-626",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-627",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.041 22.294)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-628",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.219 6.628)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-629",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.268)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-24",
    "data-name": "clarity:boat-line",
    transform: "translate(505.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-630",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-631",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.041 22.295)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-632",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.219 6.63)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-633",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.269)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6982-5",
    "data-name": "Group 6982",
    transform: "translate(23.282 378.32)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-40",
    "data-name": "majesticons:airplane",
    transform: "translate(1420.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-140",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-634",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-38",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(109.181 153.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-141",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-635",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-636",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-637",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-638",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.524 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-639",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-640",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-641",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-35",
    "data-name": "fluent:building-24-regular",
    transform: "translate(209.433 135.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-142",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-642",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-39",
    "data-name": "la:shuttle-van",
    transform: "translate(26.664 72.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-643",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-34",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(26.769 217.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-143",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-644",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-645",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.14 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-34",
    "data-name": "bx:bx-trip",
    transform: "translate(195.68 257.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-646",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-647",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.431)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-40",
    "data-name": "la:cash-register",
    transform: "translate(102.99 310.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-648",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-25",
    "data-name": "clarity:boat-line",
    transform: "translate(0 335.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-649",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-650",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-651",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.031 11.049)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-652",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6984-2",
    "data-name": "Group 6984",
    transform: "translate(128.119 985.005)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-41",
    "data-name": "majesticons:airplane",
    transform: "translate(182.467 228.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-144",
    "data-name": "Group",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-653",
    "data-name": "Vector",
    d: "M54.157,32.573H68.707a9.048,9.048,0,0,0,0-18.1H18.465a3.619,3.619,0,0,1-3.236-2L13.608,9.24a3.619,3.619,0,0,0-3.236-2H3.622a3.619,3.619,0,0,0-3.33,5.045l7.756,18.1a3.619,3.619,0,0,0,3.33,2.193H25.359a3.619,3.619,0,0,1,3.359,4.962l-3.261,8.176a3.619,3.619,0,0,0,3.355,4.958H36.2a3.619,3.619,0,0,0,2.827-1.357L51.334,33.93a3.619,3.619,0,0,1,2.823-1.357ZM28.9,10.858H46.087l-7.057-9.41A3.619,3.619,0,0,0,36.134,0H29.322a3.619,3.619,0,0,0-3.236,5.237Z",
    transform: "translate(0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-39",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(82.52 130.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-145",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-654",
    "data-name": "Vector",
    d: "M54.288,25.971c0,17.2-14.477,31.936-27.144,31.936S0,43.168,0,25.971C0,12.041,10.664,0,27.144,0S54.288,12.041,54.288,25.971Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-655",
    "data-name": "Vector",
    d: "M0,0C6.7,6.911,12.667,18.313,12.667,28.954,12.667,39.462,6.551,51.016,0,57.907",
    transform: "translate(28.953)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-656",
    "data-name": "Vector",
    d: "M12.667,0A39.651,39.651,0,0,0,0,28.954,40.525,40.525,0,0,0,12.667,57.907",
    transform: "translate(12.667 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-657",
    "data-name": "Vector",
    d: "M0,5.461s9.166,1.84,16.286,0A47.757,47.757,0,0,0,28.954,0",
    transform: "translate(23.524 16.286)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-658",
    "data-name": "Vector",
    d: "M0,0S9.048,4.524,16.286,6.334a44.662,44.662,0,0,0,14.477.9",
    transform: "translate(0 28.954)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-659",
    "data-name": "Vector",
    d: "M0,0,2.533,12.839s4.931,3.447,8.324,3.447,8.324-3.447,8.324-3.447L21.7.054,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-660",
    "data-name": "Vector",
    d: "M21.715,0,21.7.054ZM21.7.054,19.182,12.839s-4.931,3.447-8.324,3.447-8.324-3.447-8.324-3.447L0,0,10.858,1.81Z",
    transform: "translate(16.286 56.098)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-36",
    "data-name": "fluent:building-24-regular",
    transform: "translate(182.769 112.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-146",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-661",
    "data-name": "Vector",
    d: "M16.286,12.667a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,12.667ZM12.667,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,12.667,41.621Zm3.619-16.286a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,16.286,25.334Zm9.048-9.048a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,25.334,16.286ZM28.954,38a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,38ZM38,41.621a3.619,3.619,0,1,1,1.06,2.559A3.619,3.619,0,0,1,38,41.621ZM28.954,25.334a3.619,3.619,0,1,0,2.559,1.06A3.619,3.619,0,0,0,28.954,25.334ZM8.143,0A8.143,8.143,0,0,0,0,8.143V67.86a2.715,2.715,0,0,0,2.714,2.714H55.2a2.714,2.714,0,0,0,2.714-2.714V35.287a8.143,8.143,0,0,0-8.143-8.143H45.24v-19A8.143,8.143,0,0,0,37.1,0ZM5.429,8.143A2.714,2.714,0,0,1,8.143,5.429H37.1a2.714,2.714,0,0,1,2.714,2.714V29.858a2.715,2.715,0,0,0,2.714,2.714h7.249a2.714,2.714,0,0,1,2.714,2.714V65.146H45.24V55.193a2.714,2.714,0,0,0-2.714-2.714H15.382a2.714,2.714,0,0,0-2.714,2.714v9.953H5.429ZM39.811,57.907v7.238H31.668V57.907Zm-13.572,0v7.238H18.1V57.907Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-40",
    "data-name": "la:shuttle-van",
    transform: "translate(0 49.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-662",
    "data-name": "Vector",
    d: "M8.143,0A8.185,8.185,0,0,0,0,8.143V54.288H8.567a10.756,10.756,0,0,0,20.868,0H49.283a10.756,10.756,0,0,0,20.868,0h8.567V25.955a8.227,8.227,0,0,0-1.273-4.324L66.335,3.816A8.094,8.094,0,0,0,59.459,0Zm0,5.429H21.715V21.715H5.429V8.143A2.68,2.68,0,0,1,8.143,5.429Zm19,0H43.431V21.715H27.144Zm21.715,0h10.6A2.683,2.683,0,0,1,61.753,6.7l9.332,15.013H48.859ZM5.429,27.144h67.86v5.429H65.146V38h8.143V48.859H70.151a10.756,10.756,0,0,0-20.868,0H29.435a10.756,10.756,0,0,0-20.868,0H5.429ZM19,46.145a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,19,46.145Zm40.716,0a5.429,5.429,0,1,1-5.429,5.429A5.386,5.386,0,0,1,59.717,46.145Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-35",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(0.108 194.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-147",
    "data-name": "Group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-663",
    "data-name": "Vector",
    d: "M57.655,6.138l5.013,32.573A7.238,7.238,0,0,1,55.52,47.05H7.239A7.238,7.238,0,0,1,.084,38.711L5.1,6.138A7.238,7.238,0,0,1,12.256,0H50.5a7.238,7.238,0,0,1,7.155,6.138Z",
    transform: "translate(0 18.097)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-664",
    "data-name": "Vector",
    d: "M14.477,7.238A7.238,7.238,0,1,0,0,7.238",
    transform: "translate(24.141 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9.583
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-35",
    "data-name": "bx:bx-trip",
    transform: "translate(123.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-665",
    "data-name": "Vector",
    d: "M46.485,65.146h-30.2a9.048,9.048,0,0,1,0-18.1H41.621a12.667,12.667,0,0,0,0-25.334H24.028a35.512,35.512,0,0,1-4.9,7.238H41.621a5.429,5.429,0,0,1,0,10.858H16.286a16.286,16.286,0,0,0,0,32.573H51.006a37.694,37.694,0,0,1-4.52-7.238ZM10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-666",
    "data-name": "Vector",
    d: "M10.858,0A10.871,10.871,0,0,0,0,10.858c0,11.538,10.858,18.1,10.858,18.1s10.858-6.562,10.858-18.1A10.871,10.871,0,0,0,10.858,0Zm0,16.286A5.431,5.431,0,1,1,14.7,14.7a5.431,5.431,0,0,1-3.841,1.589Z",
    transform: "translate(50.669 43.431)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-41",
    "data-name": "la:cash-register",
    transform: "translate(76.329 287.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-667",
    "data-name": "Vector",
    d: "M49.622,0V10.858a43.169,43.169,0,0,0-14.294,2.47L33.9,10.212l2.448-1.094-2.2-4.962L24.229,8.567l2.2,4.962,2.5-1.113,1.39,3a43.772,43.772,0,0,0-8.26,5.4l-2.134-2.269,1.973-1.813-3.667-4.006-8,7.348,3.67,4.006,2.014-1.857,2.185,2.3a43.238,43.238,0,0,0-6.639,9.215L8.534,32.288l1.221-2.4L4.919,27.429,0,37.111l4.834,2.459,1.24-2.448,3.108,1.547a43.192,43.192,0,0,0-2.856,12.9H.763V67.86H65.909V0Zm5.429,5.429H60.48V51.574H11.756A37.934,37.934,0,0,1,49.622,16.286h5.429ZM38.764,24.3A5.432,5.432,0,0,0,36.05,34.44v11.7H49.622V40.716H41.479V34.43A5.423,5.423,0,0,0,38.764,24.3ZM6.192,57H60.48v5.429H6.192Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6981-4",
    "data-name": "Group 6981",
    transform: "translate(1200.129 57.401)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-42",
    "data-name": "majesticons:airplane",
    transform: "translate(78.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-148",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-668",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.417.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-40",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.147 62.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-149",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-669",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-670",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.371)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-671",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-672",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-673",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-674",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.771 33.658)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-675",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.771 33.658)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-37",
    "data-name": "fluent:building-24-regular",
    transform: "translate(148.751 45.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-150",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-676",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257ZM23.887,34.744v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-41",
    "data-name": "la:shuttle-van",
    transform: "translate(0 5.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-677",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-36",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.489 99.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-151",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-678",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-679",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,1,0,0,4.343",
    transform: "translate(14.485)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-36",
    "data-name": "bx:bx-trip",
    transform: "translate(10.491 250.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-680",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,0,1,0-10.858h15.2a7.6,7.6,0,0,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,0,0,0,19.544H30.6a22.617,22.617,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-681",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.058)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-42",
    "data-name": "la:cash-register",
    transform: "translate(67.946 165.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-682",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.76,22.76,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6975-2",
    "data-name": "Group 6975",
    transform: "translate(513.545 602.997)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-43",
    "data-name": "majesticons:airplane",
    transform: "translate(58.666 177.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-152",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-683",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.417.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-41",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(65.145 68.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-153",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-684",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-685",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-686",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-687",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-688",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.372)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-689",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-690",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-38",
    "data-name": "fluent:building-24-regular",
    transform: "translate(163.951 58.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-154",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-691",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257ZM23.887,34.744v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-42",
    "data-name": "la:shuttle-van",
    transform: "translate(0 11.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-692",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-37",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(10.489 105.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-155",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-693",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-694",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,1,0,0,4.343",
    transform: "translate(14.484)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-37",
    "data-name": "bx:bx-trip",
    transform: "translate(118.349 121.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-695",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,0,1,0-10.858h15.2a7.6,7.6,0,0,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,0,0,0,19.544H30.6a22.617,22.617,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-696",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.059)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-43",
    "data-name": "la:cash-register",
    transform: "translate(87.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-697",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.76,22.76,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6978-4",
    "data-name": "Group 6978",
    transform: "translate(389.713 361.957)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-44",
    "data-name": "majesticons:airplane",
    transform: "translate(194.521 177.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-156",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-698",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.417.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-42",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(0 36.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-157",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-699",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-700",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.372)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-701",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-702",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-703",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.372)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-704",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-705",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-39",
    "data-name": "fluent:building-24-regular",
    transform: "translate(476.606 37.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-158",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-706",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257ZM23.887,34.744v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-43",
    "data-name": "la:shuttle-van",
    transform: "translate(135.856 11.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-707",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-38",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(146.345 105.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-159",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-708",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.858)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-709",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,1,0,0,4.343",
    transform: "translate(14.484)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-38",
    "data-name": "bx:bx-trip",
    transform: "translate(280.263 138.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-710",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,0,1,0-10.858h15.2a7.6,7.6,0,0,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,0,0,0,19.544H30.6a22.617,22.617,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-711",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.059)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-44",
    "data-name": "la:cash-register",
    transform: "translate(223.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-712",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.76,22.76,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6980-4",
    "data-name": "Group 6980",
    transform: "translate(346.362 94.859)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "majesticons:airplane-45",
    "data-name": "majesticons:airplane",
    transform: "translate(74.52 247.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-160",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-713",
    "data-name": "Vector",
    d: "M32.494,19.544h8.73a5.429,5.429,0,0,0,0-10.858H11.079a2.172,2.172,0,0,1-1.941-1.2L8.165,5.544a2.172,2.172,0,0,0-1.941-1.2H2.173a2.172,2.172,0,0,0-2,3.027L4.829,18.228a2.172,2.172,0,0,0,2,1.316h8.389a2.172,2.172,0,0,1,2.015,2.977l-1.957,4.905A2.172,2.172,0,0,0,17.287,30.4h4.434a2.172,2.172,0,0,0,1.7-.814L30.8,20.358a2.172,2.172,0,0,1,1.694-.814ZM17.337,6.515H27.652L23.417.869A2.172,2.172,0,0,0,21.68,0H17.593a2.172,2.172,0,0,0-1.941,3.142Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:hot-air-balloon-43",
    "data-name": "icon-park-outline:hot-air-balloon",
    transform: "translate(0 211.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-161",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-714",
    "data-name": "Vector",
    d: "M32.573,15.583c0,10.318-8.686,19.162-16.286,19.162S0,25.9,0,15.583C0,7.225,6.4,0,16.286,0S32.573,7.225,32.573,15.583Z",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-715",
    "data-name": "Vector",
    d: "M0,0C4.017,4.147,7.6,10.988,7.6,17.372,7.6,23.677,3.93,30.61,0,34.744",
    transform: "translate(17.371 0)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-716",
    "data-name": "Vector",
    d: "M7.6,0A23.791,23.791,0,0,0,0,17.372,24.315,24.315,0,0,0,7.6,34.744",
    transform: "translate(7.6)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-717",
    "data-name": "Vector",
    d: "M0,3.277s5.5,1.1,9.772,0A28.654,28.654,0,0,0,17.372,0",
    transform: "translate(14.115 9.772)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-718",
    "data-name": "Vector",
    d: "M0,0A58.731,58.731,0,0,0,9.772,3.8a26.8,26.8,0,0,0,8.686.543",
    transform: "translate(0 17.373)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-719",
    "data-name": "Vector",
    d: "M0,0,1.52,7.7S4.479,9.772,6.515,9.772,11.509,7.7,11.509,7.7L13.023.033,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-720",
    "data-name": "Vector",
    d: "M13.029,0l-.007.033Zm-.007.033L11.509,7.7S8.55,9.772,6.515,9.772,1.52,7.7,1.52,7.7L0,0,6.515,1.086Z",
    transform: "translate(9.772 33.658)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.396
  }))), /*#__PURE__*/React.createElement("g", {
    id: "fluent:building-24-regular-40",
    "data-name": "fluent:building-24-regular",
    transform: "translate(270.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-162",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-721",
    "data-name": "Vector",
    d: "M9.772,7.6a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,7.6ZM7.6,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,7.6,24.973ZM9.772,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,9.772,15.2ZM15.2,9.772a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,15.2,9.772ZM17.372,22.8a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,22.8ZM22.8,24.973a2.172,2.172,0,1,1,.636,1.536A2.172,2.172,0,0,1,22.8,24.973ZM17.372,15.2a2.172,2.172,0,1,0,1.535.636A2.172,2.172,0,0,0,17.372,15.2ZM4.886,0A4.886,4.886,0,0,0,0,4.886v35.83a1.629,1.629,0,0,0,1.629,1.629H33.122a1.629,1.629,0,0,0,1.629-1.629V21.172a4.886,4.886,0,0,0-4.886-4.886H27.144V4.886A4.886,4.886,0,0,0,22.258,0ZM3.257,4.886A1.629,1.629,0,0,1,4.886,3.257H22.258a1.629,1.629,0,0,1,1.629,1.629V17.915a1.629,1.629,0,0,0,1.629,1.629h4.35a1.629,1.629,0,0,1,1.629,1.629V39.087h-4.35V33.116a1.629,1.629,0,0,0-1.629-1.629H9.229A1.629,1.629,0,0,0,7.6,33.116v5.972H3.257ZM23.887,34.744v4.343H19V34.744Zm-8.143,0v4.343H10.858V34.744Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "la:shuttle-van-44",
    "data-name": "la:shuttle-van",
    transform: "translate(66.854 11.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-722",
    "data-name": "Vector",
    d: "M4.886,0A4.911,4.911,0,0,0,0,4.886V32.573H5.14a6.454,6.454,0,0,0,12.521,0H29.57a6.454,6.454,0,0,0,12.521,0h5.14v-17a4.936,4.936,0,0,0-.764-2.594L39.8,2.29A4.857,4.857,0,0,0,35.675,0Zm0,3.257h8.143v9.772H3.257V4.886A1.608,1.608,0,0,1,4.886,3.257Zm11.4,0h9.772v9.772H16.286Zm13.029,0h6.361a1.61,1.61,0,0,1,1.375.764l5.6,9.008H29.316ZM3.257,16.286H43.973v3.257H39.087V22.8h4.886v6.515H42.091a6.454,6.454,0,0,0-12.521,0H17.661a6.454,6.454,0,0,0-12.521,0H3.257Zm8.143,11.4a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,11.4,27.687Zm24.43,0a3.257,3.257,0,1,1-3.257,3.257A3.232,3.232,0,0,1,35.83,27.687Z",
    transform: "translate(0 0)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iconoir:shopping-bag-39",
    "data-name": "iconoir:shopping-bag",
    transform: "translate(42.344 125.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-163",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-723",
    "data-name": "Vector",
    d: "M34.593,3.683,37.6,23.227a4.343,4.343,0,0,1-4.289,5H4.344a4.343,4.343,0,0,1-4.293-5L3.058,3.683A4.343,4.343,0,0,1,7.353,0H30.3A4.343,4.343,0,0,1,34.6,3.683Z",
    transform: "translate(0 10.857)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-724",
    "data-name": "Vector",
    d: "M8.686,4.343A4.343,4.343,0,1,0,0,4.343",
    transform: "translate(14.484)",
    fill: "none",
    stroke: "#1e3460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.792
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bx:bx-trip-39",
    "data-name": "bx:bx-trip",
    transform: "translate(185.203 121.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-725",
    "data-name": "Vector",
    d: "M27.891,39.087H9.772a5.429,5.429,0,0,1,0-10.858h15.2a7.6,7.6,0,0,0,0-15.2H14.417a21.307,21.307,0,0,1-2.94,4.343h13.5a3.257,3.257,0,0,1,0,6.515H9.772a9.772,9.772,0,0,0,0,19.544H30.6a22.617,22.617,0,0,1-2.712-4.343ZM6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-726",
    "data-name": "Vector",
    d: "M6.515,0A6.523,6.523,0,0,0,0,6.515c0,6.923,6.515,10.858,6.515,10.858s6.515-3.937,6.515-10.858A6.523,6.523,0,0,0,6.515,0Zm0,9.772a3.258,3.258,0,1,1,2.3-.954,3.258,3.258,0,0,1-2.3.954Z",
    transform: "translate(30.401 26.058)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "la:cash-register-45",
    "data-name": "la:cash-register",
    transform: "translate(1123.344 45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-727",
    "data-name": "Vector",
    d: "M29.773,0V6.515A25.9,25.9,0,0,0,21.2,8l-.858-1.87,1.469-.656L20.485,2.493,14.537,5.14,15.86,8.117l1.5-.668.834,1.8a26.264,26.264,0,0,0-4.956,3.238l-1.28-1.362,1.184-1.088-2.2-2.4-4.8,4.409,2.2,2.4,1.208-1.114,1.311,1.381a25.943,25.943,0,0,0-3.984,5.529L5.12,19.373l.733-1.438-2.9-1.477L0,22.267l2.9,1.476.744-1.469L5.51,23.2A25.915,25.915,0,0,0,3.8,30.944H.458v9.772H39.545V0Zm3.257,3.257h3.257V30.944H7.054A22.76,22.76,0,0,1,29.773,9.772h3.257ZM23.259,14.581a3.259,3.259,0,0,0-1.629,6.083v7.023h8.143V24.43H24.887V20.658a3.254,3.254,0,0,0-1.629-6.075ZM3.715,34.2H36.288v3.257H3.715Z",
    fill: "#1e3460"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-26",
    "data-name": "clarity:boat-line",
    transform: "translate(736.654 348.348)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-728",
    "data-name": "Vector",
    d: "M65.387.241A9.918,9.918,0,0,0,57.907,2.9a7.139,7.139,0,0,1-9.893,0A13.709,13.709,0,0,0,40.053.241,10.687,10.687,0,0,0,32.09,2.9a7.787,7.787,0,0,1-5.067,1.93A7.787,7.787,0,0,1,21.957,2.9a13.069,13.069,0,0,0-16.407,0A9.109,9.109,0,0,1,0,4.826V9.651a11.57,11.57,0,0,0,8.686-2.9,9.109,9.109,0,0,1,5.549-1.93A8.3,8.3,0,0,1,19.3,6.756a12.065,12.065,0,0,0,15.683,0,7.787,7.787,0,0,1,5.067-1.93,7.663,7.663,0,0,1,4.826,1.93,12.067,12.067,0,0,0,15.683,0,7.173,7.173,0,0,1,4.826-1.93,6.592,6.592,0,0,1,4.584,1.93,13.584,13.584,0,0,0,7.238,2.9V4.826c-2.413,0-2.9-.965-4.1-1.93A12.467,12.467,0,0,0,65.387.241Z",
    transform: "translate(0 54.047)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-729",
    "data-name": "Vector",
    d: "M4.584,7.238A2.48,2.48,0,0,1,7.238,4.826H67.317l-8.445,7.48h.483a12.283,12.283,0,0,1,5.308,1.206L70.7,8.2l.483-.483A4.9,4.9,0,0,0,70.7.965,6.843,6.843,0,0,0,67.559,0H7.238A7.109,7.109,0,0,0,0,7.238v7.721a14.3,14.3,0,0,1,4.584-2.654V7.238Z",
    transform: "translate(5.068 37.157)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-730",
    "data-name": "Vector",
    d: "M4.618,23.7H19.336V4.876a5.037,5.037,0,0,0-1.93-3.86,4.691,4.691,0,0,0-6.756.965L.757,16.216a5.366,5.366,0,0,0-.241,5.067,4.67,4.67,0,0,0,4.1,2.413ZM14.752,4.876,14.51,18.87H4.618Z",
    transform: "translate(12.032 11.049)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-731",
    "data-name": "Vector",
    d: "M24.128,32.332a4.383,4.383,0,0,0,0-4.826L8.927,2.413A4.976,4.976,0,0,0,4.826,0,4.84,4.84,0,0,0,0,4.826V34.744H20.026A4.67,4.67,0,0,0,24.128,32.332ZM4.584,4.826,20.026,30.16H4.584Z",
    transform: "translate(33.78)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-27",
    "data-name": "clarity:boat-line",
    transform: "translate(808.208 745.919)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-732",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-733",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.041 22.294)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-734",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.218 6.628)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-735",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.268)",
    fill: "#1e3460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clarity:boat-line-28",
    "data-name": "clarity:boat-line",
    transform: "translate(66.955 908.784)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-736",
    "data-name": "Vector",
    d: "M39.232.145a5.951,5.951,0,0,0-4.488,1.592,4.283,4.283,0,0,1-5.936,0A8.225,8.225,0,0,0,24.032.145a6.412,6.412,0,0,0-4.777,1.592A4.672,4.672,0,0,1,16.214,2.9a4.672,4.672,0,0,1-3.04-1.158,7.842,7.842,0,0,0-9.844,0A5.465,5.465,0,0,1,0,2.9v2.9A6.942,6.942,0,0,0,5.212,4.054,5.465,5.465,0,0,1,8.541,2.9a4.979,4.979,0,0,1,3.04,1.158,7.239,7.239,0,0,0,9.41,0A4.672,4.672,0,0,1,24.032,2.9a4.6,4.6,0,0,1,2.9,1.158,7.24,7.24,0,0,0,9.41,0,4.3,4.3,0,0,1,2.9-1.158,3.955,3.955,0,0,1,2.751,1.158,8.15,8.15,0,0,0,4.343,1.737V2.9c-1.448,0-1.737-.579-2.461-1.158A7.48,7.48,0,0,0,39.232.145Z",
    transform: "translate(0 32.428)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-737",
    "data-name": "Vector",
    d: "M2.751,4.343A1.488,1.488,0,0,1,4.343,2.9H40.39L35.323,7.383h.29a7.37,7.37,0,0,1,3.185.724l3.619-3.185.29-.29a2.938,2.938,0,0,0-.29-4.054A4.106,4.106,0,0,0,40.535,0H4.343A4.266,4.266,0,0,0,0,4.343V8.976A8.58,8.58,0,0,1,2.751,7.383V4.343Z",
    transform: "translate(3.041 22.294)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-738",
    "data-name": "Vector",
    d: "M2.771,14.218H11.6V2.926A3.022,3.022,0,0,0,10.443.609a2.815,2.815,0,0,0-4.054.579L.454,9.73A3.219,3.219,0,0,0,.31,12.77a2.8,2.8,0,0,0,2.461,1.448ZM8.851,2.926l-.145,8.4H2.771Z",
    transform: "translate(7.22 6.629)",
    fill: "#1e3460"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-739",
    "data-name": "Vector",
    d: "M14.477,19.4a2.63,2.63,0,0,0,0-2.9L5.356,1.448A2.986,2.986,0,0,0,2.9,0,2.9,2.9,0,0,0,0,2.9V20.847H12.016A2.8,2.8,0,0,0,14.477,19.4ZM2.751,2.9l9.265,15.2H2.751Z",
    transform: "translate(20.268)",
    fill: "#1e3460"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatterns);
export default __webpack_public_path__ + "static/media/PATTERNS.77f5e63d01b628e37c7cb624a8ca152a.svg";
export { ForwardRef as ReactComponent };